import { OrganizationPaginated } from "./OrganizationPaginated";
import ServerResponse from "./ServerResponse";

export class OrganizationServerResponse extends ServerResponse {

    constructor() {
        super();
        this.data = new OrganizationPaginated();
    }

    /**
     * @type {OrganizationPaginated}
     */
    data;
}
